function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  )
}

function generateBorders() {
  // Select all elements with grid classes
  const gridCols = document.querySelectorAll('.grid-cols-4, .grid-cols-3, .grid-cols-2');

  // Define media queries for different screen sizes
  const xs = window.matchMedia('(max-width: 767px)');
  const sm = window.matchMedia('(min-width: 768px) and (max-width: 1023px)');
  const md = window.matchMedia('(min-width: 1024px) and (max-width: 1199px)');
  const lg = window.matchMedia('(min-width: 1200px)');
  
  // Loop through each grid column
  gridCols.forEach((col) => {
    let num = 2;

    // Adjust number of items per row based on screen size and column class
    if (col.classList.contains('grid-cols-3')) {
      num = xs.matches ? 1 : (sm.matches ? 2 : 3);
    } else if (col.classList.contains('grid-cols-4')) {
      num = lg.matches ? 4 : (md.matches ? 3 : (sm.matches ? 2 : 1));
    }

    // Check if the number of items is not divisible by num
    const items = Array.from(col.children);
    const lastItems = items.length % num;

    // Loop through items and add/remove border classes accordingly
    items.forEach((item, index) => {
      if (index < items.length - lastItems) {
        if (lastItems !== 0) {
          item.classList.remove('no-border');
          item.classList.add('border-bottom');
        } else {
          item.classList.remove('border-bottom');
          item.classList.add('no-border');
        }
      }
    });
  });
}
  
const elems = document.querySelectorAll('.announcement-bar, .sub-nav');

window.addEventListener('load', generateBorders)
window.addEventListener('resize', generateBorders);

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button')
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'))

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id)
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    )
  })

  if (summary.closest('header-drawer, menu-drawer')) return
  summary.parentElement.addEventListener('keyup', onKeyUpEscape)
})

const trapFocusHandlers = {}

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container)
  var first = elements[0]
  var last = elements[elements.length - 1]

  removeTrapFocus()

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return

    document.addEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown)
  }

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault()
      first.focus()
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault()
      last.focus()
    }
  }

  document.addEventListener('focusout', trapFocusHandlers.focusout)
  document.addEventListener('focusin', trapFocusHandlers.focusin)

  elementToFocus.focus()

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length)
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible')
} catch (e) {
  focusVisiblePolyfill()
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ]
  let currentFocusedElement = null
  let mouseClick = null

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false
    }
  })

  window.addEventListener('mousedown', (event) => {
    mouseClick = true
  })

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused')

      if (mouseClick) return

      currentFocusedElement = document.activeElement
      currentFocusedElement.classList.add('focused')
    },
    true
  )
}
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin)
  document.removeEventListener('focusout', trapFocusHandlers.focusout)
  document.removeEventListener('keydown', trapFocusHandlers.keydown)

  if (elementToFocus) elementToFocus.focus()
}
function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return

  const openDetailsElement = event.target.closest('details[open]')
  if (!openDetailsElement) return

  const summaryElement = openDetailsElement.querySelector('summary')
  openDetailsElement.removeAttribute('open')
  summaryElement.setAttribute('aria-expanded', false)
  summaryElement.focus()
}
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {}
}
Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments)
  }
}

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i]
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i
      return i
    }
  }
}

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback)
}

Shopify.postLink = function (path, options) {
  options = options || {}
  var method = options['method'] || 'post'
  var params = options['parameters'] || {}

  var form = document.createElement('form')
  form.setAttribute('method', method)
  form.setAttribute('action', path)

  for (var key in params) {
    var hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', key)
    hiddenField.setAttribute('value', params[key])
    form.appendChild(hiddenField)
  }
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid)
  this.provinceEl = document.getElementById(province_domid)
  this.provinceContainer = document.getElementById(
    options['hideElement'] || province_domid
  )

  Shopify.addListener(
    this.countryEl,
    'change',
    Shopify.bind(this.countryHandler, this)
  )

  this.initCountry()
  this.initProvince()
}

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default')
    Shopify.setSelectorByValue(this.countryEl, value)
    this.countryHandler()
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default')
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value)
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex]
    var raw = opt.getAttribute('data-provinces')
    var provinces = JSON.parse(raw)

    this.clearOptions(this.provinceEl)
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none'
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option')
        opt.value = provinces[i][0]
        opt.innerHTML = provinces[i][1]
        this.provinceEl.appendChild(opt)
      }

      this.provinceContainer.style.display = ''
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild)
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option')
      opt.value = values[i]
      opt.innerHTML = values[i]
      selector.appendChild(opt)
    }
  },
}

Element.prototype.setAttributes = function (obj) {
  for (var prop in obj) {
    this.setAttribute(prop, obj[prop])
  }
}
function debounce(callback, wait) {
  let timeout
  return (...args) => {
    const context = this
    clearTimeout(timeout)
    timeout = setTimeout(() => callback.apply(context, args), wait)
  }
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    )
  })
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*')
  })

  // Pause all native media elements (audio, video) within media-player components
  document.querySelectorAll('audio, video').forEach((media) => {
    const mediaPlayer = media.closest('media-player')
    if (mediaPlayer !== this) {
      const playerBtn = mediaPlayer.querySelectorAll('.media-player__button')
      media.pause()
      playerBtn.forEach((btn) => {
        btn.setAttribute('data-state', 'play')
      })
    } else if (!media.paused) {
      media.pause()
    }
  })
  // Way to detect what element is playing video or audio
  // is playing that is not vimeo or youtube and doesn't use postMessage API
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause()
  })
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  }
}
class DeferredMedia extends HTMLElement {
  constructor() {
    super()
    const poster = this.querySelector('[id^="Deferred-Poster-"]')

    if (!poster) return
    poster.addEventListener('click', this.loadContent.bind(this))
  }

  loadContent(focus = true) {
    window.pauseAllMedia()
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div')
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      )
      this.setAttribute('loaded', true)
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe, audio')
      )
      if (focus) deferredElement.focus()
    }
  }
}
customElements.define('deferred-media', DeferredMedia)

class MembershipProduct extends HTMLElement {
  constructor() {
    super()
    this.updateMembershipPlans()
    this.forms = this.querySelectorAll('form')
  }
  updateMembershipPlans() {
    const sellingPlans = this.querySelector('.selling-plan__options')
    const tiers = this.querySelectorAll('.membership__tier')
    if (sellingPlans !== null) {
      sellingPlans.addEventListener('change', (e) => {
        const plan = parseInt(e.target.value)
        tiers.forEach((tier) => {
          const price = tier.querySelector('.membership__tier-price [data-price]')
          const compare = tier.querySelector('.membership__tier-price [data-compare]')
          const plans = JSON.parse(tier.querySelector('script').textContent)
          const input = tier.querySelector('input[name="selling_plan"]')
          const currentPlan = plans.find((p) => p.plan_id === plan)
          if(currentPlan.plan_compare === null) { 
            compare.innerHTML = ''
          } else {
            compare.innerHTML = currentPlan.plan_compare
          }
          price.innerHTML= currentPlan.plan_price
          input.value = plan
        })
      })
    }
  }
  returnTo() { 
    this.forms.forEach(form => { 
      const checkout = document.createElement('input')
      checkout.type = 'hidden'
      checkout.value = '/checkout'
      checkout.name = 'return_to'
      form.insertAdjacentElement('beforeend', checkout)
    })
  }
}
customElements.define('membership-product', MembershipProduct)

class ReturnTo extends HTMLElement {
  constructor() {
    super();
    this.returnTo = this.querySelector('input[name="return_to"]');
  }
  connectedCallback() {
    this.updateValue();
  }
  updateValue() {
    const returnPath = document.referrer;
    const host = window.location.origin;
    const url = new URL(returnPath);
    if (url.searchParams.has('variant')) {
      url.searchParams.delete('variant');
    }
    const returnTo = url.toString();
    this.returnTo.value = returnTo.replace(host, '');
  }
}
customElements.define('return-to', ReturnTo);

class VariantSelects extends HTMLElement {
  constructor() {
    super()
    this.productInfo = this.closest('product-info')
    // this.sellingPlans = this.parentElement.querySelector('selling-plans')
    this.shortCode = this.productInfo.dataset.shortcode === "true" ? true : false
    this.addEventListener('change', () => this.onVariantChange())
  }
  onVariantChange() {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()
    this.removeErrorMessage()
    this.updateVariantStatuses()

    const event = new CustomEvent('update-plans', { 
      bubbles: true,
      compose: true, 
      detail: { 
        section: this.dataset.section, 
        currentVariant: this.currentVariant, 
        isShortCode: this.shortCode, 
        sellingPlan: this.sellingPlan
      }
    })
    this.dispatchEvent(event)

    if (!this.currentVariant) {
      if(!this.shortcode) {
        this.toggleAddButton(true, '', true)
        this.setUnavailable()
      }
    } else {
      this.updateMedia()
      this.updateURL()
      this.updateVariantInput()
      this.updateShareUrl()

      if (this.shortCode) {
        this.renderShortCode()
      } else {
        this.renderProductInfo()
      }
    }
  }
  updateOptions() {
    // this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);

    this.options = [];
    const fields = Array.from(this.querySelectorAll('select, fieldset'));
    fields.forEach((field) => {
       if (field.tagName.toLowerCase() === 'select') {
         this.options.push(field.value);
       } else if (field.tagName.toLowerCase() === 'fieldset') {
         const checkedRadio = Array.from(field.querySelectorAll('input[type="radio"]')).find((radio) => radio.checked);
         if (checkedRadio) {
             this.options.push(checkedRadio.value);
         }
       }
    })
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
    if(this.currentVariant) {
      this.productInfo.setAttribute('data-variant', this.currentVariant.id)
    }
  }
  updateMedia() {
    if (!this.currentVariant) return
    if (!this.currentVariant.featured_media) return

    const currentId = this.currentVariant.featured_media.id
    const product = this.closest('.product')
    const featuredMedia = product.querySelector(
      `[data-featured-id="${currentId}"]`
    )
    featuredMedia.classList.remove('hidden')
    const allMedia =
      featuredMedia.parentNode.querySelectorAll('[data-featured-id]')
    allMedia.forEach((media) => {
      if (media !== featuredMedia) {
        media.classList.add('hidden')
      }
    })

    const currentThumbnail = document.querySelector(
      `[data-thumbnail-id="${currentId}"]`
    )
    if(currentThumbnail) {
      currentThumbnail.classList.add('current')
      const thumbnails = currentThumbnail.parentNode.querySelectorAll(
        '[data-thumbnail-id]'
      )
      thumbnails.forEach((thumbnail) => {
        if (thumbnail !== currentThumbnail) {
          thumbnail.classList.remove('current')
        }
      })
    }
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return
    const searchParams = new URLSearchParams(window.location.search)
    searchParams.set('variant', `${this.currentVariant.id}`)
    window.history.replaceState({}, '', `${this.dataset.url}?${searchParams}`)
  }
  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`)
    if (!shareButton || !shareButton.updateUrl) return
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }
  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    )
    const inputWrappers = [...this.querySelectorAll('.product-form__input')]
    inputWrappers.forEach((option, index) => {
      if (index === 0) return
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ]
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(':checked').value
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`])

      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    })
  }
  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value')
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value')
        )
      }
    })
  }
  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }
  removeErrorMessage() {
    const section = this.closest('product-info')
    if (!section) return
    const productForm = section.querySelector('product-form')
    if (productForm) productForm.handleErrorMessage()
  }
  renderShortCode() {
    const event = new CustomEvent('variant-changed', {
      composed: true,
      bubbles: true,
    })
    this.updateSKU()
    this.updatePrice()
    this.updateAddButton()
    this.dispatchEvent(event)
  }
  updateSKU() {
    const SKU = this.productInfo.querySelector(
      `#Sku-${this.productInfo.dataset.section}`
    )
    if (SKU !== null) {
      SKU.innerHTML = ''
      if (this.currentVariant.sku !== '') {
        SKU.innerHTML = this.currentVariant.sku
      }
    }
  }
  updatePrice() {
    const priceContainer = this.productInfo.querySelector('.price')
    const priceElem = priceContainer.querySelector('[data-price]')
    const comparePriceElem = priceContainer.querySelector(
      '[data-compare-price]'
    )
    const discountElem = priceContainer.querySelector('[data-discount-savings]')

    let price = this.currentVariant.price
    let comparePrice = this.currentVariant.compare_at_price
    let discount = this.currentVariant.discount

    if(this.currentVariant.subscriptions_only) { 
      const sellingPlan = this.sellingPlan !== undefined ? this.currentVariant.selling_plans.find(plan => plan.id === this.sellingPlan.id) : this.currentVariant.selling_plans[1]

      if(sellingPlan) {
        price = sellingPlan.price
        comparePrice = sellingPlan.compare_at_price
        discount = sellingPlan.adjustment_discount
      } else { 
        console.log('testing')
        price = this.currentVariant.selling_plans[0].price
        comparePrice = this.currentVariant.selling_plans[0].comparePrice
        discount = this.currentVariant.selling_plans[0].discount
      }
    }
    
    // Set Price
    priceElem.textContent = `${window.cartStrings.iso_symbol}${price} ${window.shopCurrencyEnabled ? window.cartStrings.iso_code : ''}`

    // Update Compare Price
    comparePriceElem.textContent = ''
    if (parseInt(price) < parseInt(comparePrice)) {
      comparePriceElem.textContent = `${window.cartStrings.iso_symbol}${comparePrice} ${window.shopCurrencyEnabled ? window.cartStrings.iso_code : ''}`
    }

    // Update Discount
    discountElem.textContent = ''
    discountElem.parentElement.classList.add('hidden')
    if (discount > 0 && price > 0) {
      discountElem.parentElement.classList.remove('hidden')
      discountElem.textContent = `${window.variantStrings.savingsText} ${discount}%`
    }
  }
  updateAddButton() {
    // grab current inventory
    const inventory = this.currentVariant.inventory
    const sectionId = this.productInfo.dataset.section
    const addButton = this.productInfo.querySelector(
      `#ProductSubmitButton-${sectionId}`
    )
    // update add to cart
    if (
      inventory.qty > 0 ||
      inventory.mgmt === null ||
      inventory.policy === 'continue'
    ) {
      addButton.removeAttribute('disabled')
      addButton.textContent = window.variantStrings.addToCart
    } else {
      addButton.setAttribute('disabled', 'disabled')
      addButton.textContent = window.variantStrings.soldOut
    }
  }
  renderProductInfo() {
    let requestedVariantId = this.currentVariant.id
    let sectionId = this.dataset.section
    let url = `${this.dataset.url}?variant=${requestedVariantId}&section_id=${sectionId}`
    const hasSellingPlan = this.sellingPlan ? true : false 

    // need to validate
    if (hasSellingPlan) {
      url = `${this.dataset.url}?variant=${requestedVariantId}&selling_plan=${this.sellingPlan.id}&section_id=${sectionId}`
    }
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${sectionId}`)
        const source = html.getElementById(`price-${sectionId}`)
        const sellingPlan = html.querySelector(`#sellingPlanWrapper-${sectionId}`)
        const sellingPlanDestination = document.querySelector(`#sellingPlanWrapper-${sectionId}`)
        const skuSource = html.getElementById(`Sku-${sectionId}`)
        const skuDestination = document.getElementById(`Sku-${sectionId}`)
        const inventorySource = html.getElementById(`Inventory-${sectionId}`)
        const inventoryDestination = document.getElementById(
          `Inventory-${sectionId}`
        )

        if (source && destination) destination.innerHTML = source.innerHTML
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML
          skuDestination.classList.toggle(
            'visibility-hidden',
            skuSource.classList.contains('visibility-hidden')
          )
        }

        if (this.currentVariant.selling_plans) {
          if(sellingPlan) { 
            sellingPlanDestination.innerHTML = sellingPlan.innerHTML
          }
          this.updatePrice(true)
        } else { 
          sellingPlanDestination.innerHTML = ""
          const sellingPlanInput = this.productInfo.querySelector('input[name="selling_plan"]')
          if(sellingPlanInput) { 
            sellingPlanInput.setAttribute("value", "")
          }
        }

        const price = document.getElementById(`price-${this.dataset.section}`)

        if (price) price.classList.remove('visibility-hidden')

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            'visibility-hidden',
            inventorySource.innerText === ''
          )

        const addButtonUpdated = html.getElementById(
          `ProductSubmitButton-${sectionId}`
        )

        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        )

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        })
      })
      .finally(() => {
        const event = new CustomEvent('variant-changed', {
          bubbles: true,
          composed: true,
        })
        this.dispatchEvent(event)
      })
  }
  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = this.productInfo.querySelector(
      `#product-form-${this.dataset.section}`
    )
    if (!productForm) return
    const addButton = productForm.querySelector('.product-form__submit')
    if (!addButton) return

    if (disable) {
      addButton.setAttribute('disabled', 'disabled')
      if (text) addButton.querySelector('.product-form__submit-text').textContent = window.variantStrings.soldOut
    } else {
      addButton.removeAttribute('disabled')
      addButton.querySelector('.product-form__submit-text').textContent = window.variantStrings.addToCart
    }

    if (!modifyClass) return
  }
  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    )
    const addButton = button.querySelector('[name="add"]')
    const price = document.getElementById(`price-${this.dataset.section}`)
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`
    )
    const sku = document.getElementById(`Sku-${this.dataset.section}`)

    if (!addButton) return
    addButton.querySelector('.product-form__submit-text').textContent = window.variantStrings.soldOut
    if (price) price.classList.add('visibility-hidden')
    if (inventory) inventory.classList.add('visibility-hidden')
    if (sku) sku.classList.add('visibility-hidden')
  }
  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.productInfo.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}
customElements.define('variant-selects', VariantSelects)

class VariantRadios extends VariantSelects {
  constructor() {
    super()
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      const label = input.parentNode.querySelector('label')
      const labelText = label.querySelector('span')
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
        labelText.textContent = input.value
      } else {
        input.classList.add('disabled');
        labelText.textContent = window.variantStrings.unavailable_with_option.replace(
          '[value]',
          input.getAttribute('value'))
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}
customElements.define('variant-radios', VariantRadios)


class SellingPlans extends HTMLElement { 
  constructor() { 
    super()
    this.productInfo = this.closest('product-info')
    this.shortCode = this.productInfo.dataset.shortcode
    this.searchParams = new URLSearchParams(window.location.search)
    this.sellingPlanInput = this.productInfo.querySelector('input[name="selling_plan"]')
    this.addEventListener('input', (e) => this.onChange(e))
    document.addEventListener('update-plans', this.variantUpdated.bind(this))
  }
  onChange(e) { 
    this.updateMasterId()
    this.updateSellingPlan(e)
  }
  variantUpdated(e) { 
    if(e.detail.isShortCode) {
      this.currentVariant = e.detail.currentVariant
      this.section = e.detail.section
      this.renderShortCodePlans()
    }
  }
  renderShortCodePlans() { 
    const currentPlans = document.querySelector(`#sellingPlanWrapper-${this.section}`) || document.querySelector(`#sellingPlanWrapper-product-form-${this.section}`)
    const pickerStyle = currentPlans.dataset.pickerStyle

    if(this.currentVariant.selling_plans) { 
      // create label and description
      let planDescText = this.currentVariant.selling_plans[0].description
      let planLabelText = this.currentVariant.selling_plans[0].group_name

      // update label and description if subscriptions only
      if(this.currentVariant.subscriptions_only) { 
        planLabelText = this.currentVariant.selling_plans[1].group_name
        planDescText = this.currentVariant.selling_plans[1].description
      }
      // create plans
      let options = ''
      this.currentVariant.selling_plans.forEach((plan,index) => { 
        if (this.currentVariant.subscriptions_only) {
          if(plan.id !== 'one_time') {
            options +=  this.createPlan(plan, index, this.section, pickerStyle, this.currentVariant.subscriptions_only)
          }
        } else {
          options +=  this.createPlan(plan, index, this.section, pickerStyle, this.currentVariant.subscriptions_only);
        }
      })
      // add plans to picker
      const elem = this.createPicker(pickerStyle,options,planLabelText,planDescText)
      currentPlans.innerHTML = ''
      currentPlans.insertAdjacentHTML('afterbegin', elem)
      currentPlans.classList.remove('hidden')
    } else { 
     // reset plans
      currentPlans.innerHTML = ''
      currentPlans.classList.add('hidden')
      const sellingPlanInput = this.productInfo.querySelector('input[name="selling_plan"]')
      if(sellingPlanInput) {
        sellingPlanInput.setAttribute("value", "")
      }
    }
  }
  getSellingPlanId(id) {  
    const activePlan = this.currentVariant.selling_plans.find(plan => { 
      const value = id === 'one_time' ? id : parseInt(id)
      return plan.id === value
    })
    this.sellingPlan = activePlan ? activePlan : this.currentVariant.selling_plans[0]
    if(!activePlan) {
      this.sellingPlanInput.value = this.sellingPlan.id
    }
  }
  updateSellingPlanId(e) { 
    const sellingPlan = this.productInfo.querySelector('input[name="selling_plan"]')
    let val = e.target.value === "one_time" ? '' : e.target.value
    if(sellingPlan) { 
      // updates existing selling plan
      sellingPlan.value = val
    } else {
      // creates a sellingPlan hidden input if it does not exists
      const form = this.productInfo.querySelector('product-form form')
      const sellingPlanElem = document.createElement('input')
      sellingPlanElem.setAttribute("type","hidden")
      sellingPlanElem.setAttribute("name", "selling_plan")
      sellingPlanElem.setAttribute("value", val)
      form.append(sellingPlanElem)
    }
    this.getSellingPlanId(e.target.value)
  }
  createPicker(style,options,label,desc) {
    if(style === 'dropdown') {
      return `
        <div class="form-field form-field--select form-field--full selling-plan__options">
          <select name="selling-plan-${this.section}" id="selling-plan">
          ${options}
          </select>
          <label for="selling-plan-${this.section}" class="form__label selling-plan__options-label">${label}</label>
          <span class="select-arrow"></span>
        </div>
        <p class="selling-plan__options-desc">${desc}</p>
      `
    } else { 
      return ` 
        <fieldset>
          <p class="selling-plan__options-label no-margin padding-bottom form__label form__label--group">${label}</p>
          ${options}
          <p class="selling-plan__options-desc">${desc}</p>
        </fieldset>
      `
    }
  }
  createPlan(plan, index, section, elem, subscriptionsOnly) { 
    const num = index + 1
    let id = `sellingPlan${num}-for-${section}`
    if(plan.id === 'one_time') { 
      id = `sellingPlanOneTime-for-${section}`
    }
    let isChecked = false
    if(subscriptionsOnly) {
      if(index === 1) { 
        isChecked = true
      }
    } else { 
      if(index === 0) { 
        isChecked = true
      }
    }
    let savingsText = ''
    if (plan.adjustment_discount > 0) {
      savingsText = ` (${window.variantStrings.savingsText} ${plan.adjustment_discount}%)`
    }

    let planText = `${plan.group_label} ${plan.name}`
    if(plan.id === 'one_time') { 
      planText = `${plan.name}`
    } else { 
      if(plan.name.toLowerCase().includes(plan.group_label.toLowerCase())) { 
        planText = `${plan.name}`;
      }
    }

    let optionText = `${planText} - ${window.cartStrings.iso_symbol}${plan.price} ${window.shopCurrencyEnabled ? window.cartStrings.iso_code : ''}${savingsText}`

    if(elem === 'button') {
      return `
        <div class="input--radio">
          <input
            type="radio"
            value="${plan.id}"
            class="selling-plan-option"
            id="${id}"
            name="sellingPlan-${section}"
            ${isChecked ? 'checked' : ''}
          >
          <label for="${id}">
            ${optionText}
          </label>
        </div>
      `
    } else { 
      return `
        <option value="${plan.id}" ${isChecked ? 'selected' : ''}>
          ${optionText}
        </option>
      ` 
    }
  }
  updateSellingPlan(e) { 
    if(this.currentVariant.selling_plans) {
      this.updateSellingPlanId(e)
      this.updatePrice()
      this.updateComparePrice()
      this.updateDiscount()
      this.updateLabel()
      this.updateDescription()
    }
  }
  updatePrice() {
    const price = this.productInfo.querySelector('[data-price]')
    price.textContent = `${window.cartStrings.iso_symbol}${this.sellingPlan.price} ${window.shopCurrencyEnabled ? window.cartStrings.iso_code : ''}`
  }
  updateComparePrice() {
    const comparePrice = this.productInfo.querySelector('[data-compare-price]')
    const priceInt = parseInt(this.sellingPlan.price)
    const compareInt = parseInt(this.sellingPlan.compare_at_price)
    if(priceInt < compareInt) { 
      comparePrice.textContent = `${window.cartStrings.iso_symbol}${this.sellingPlan.compare_at_price} ${window.shopCurrencyEnabled ? window.cartStrings.iso_code : ''}`
    } else { 
      comparePrice.textContent = ''
    }
  }
  updateDiscount() {
    const discount = this.productInfo.querySelector('[data-discount-savings]')
    const int = parseInt(this.sellingPlan.adjustment_discount)
    const price = parseInt(this.sellingPlan.price)
    if(int > 0 && price > 0) { 
      discount.parentElement.classList.remove('hidden')
      discount.textContent = `${window.variantStrings.savingsText} ${this.sellingPlan.adjustment_discount}%`
    } else {
      discount.parentElement.classList.add('hidden')
      discount.textContent = ''
    }
  }
  updateLabel() {
    const groupName = this.querySelector('.selling-plan__options-label')
    groupName.textContent = this.sellingPlan.group_name
  }
  updateDescription() {
    const description = this.querySelector('.selling-plan__options-desc')
    description.innerHTML = this.sellingPlan.description
    description.classList.remove('hidden')
    if (this.sellingPlan.description === '') {
      description.classList.add('hidden')
      description.innerHTML = ''
    }
  }
  getVariantsData() {
    this.variantData =
      this.variantData ||
      JSON.parse(
        this.productInfo.querySelector('[type="application/json"]').textContent
      )
    return this.variantData
  }
  updateMasterId() {
    let currentVariant = this.productInfo.dataset.variant
    this.currentVariant = this.getVariantsData().find((variant) => { 
      return variant.id === parseInt(currentVariant)
    })
  }
}
customElements.define('selling-plans', SellingPlans)



class ProductRecommendations extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return
      observer.unobserve(this)

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div')
          html.innerHTML = text
          const recommendations = html.querySelector('product-recommendations')

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove()
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded')
          }
        })
        .catch((e) => {
          console.error(e)
        })
    }

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this)
  }
}
class QuantityInput extends HTMLElement {
  constructor() {
    super()
    this.input = this.querySelector('input')
    this.changeEvent = new Event('change', { bubbles: true })
    this.input.addEventListener('change', this.onInputChange.bind(this))
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    )
  }

  quantityUpdateUnsubscriber = undefined

  connectedCallback() {
    this.validateQtyRules()
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    )
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber()
    }
  }

  onInputChange(event) {
    this.validateQtyRules()
  }

  onButtonClick(event) {
    event.preventDefault()
    const previousValue = this.input.value
    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown()
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent)
  }

  validateQtyRules() {
    const value = parseInt(this.input.value)
    if (this.input.min) {
      const min = parseInt(this.input.min)
      const buttonMinus = this.querySelector(".quantity__button[name='minus']")
      buttonMinus.classList.toggle('disabled', value <= min)
    }
    if (this.input.max) {
      const max = parseInt(this.input.max)
      const buttonPlus = this.querySelector(".quantity__button[name='plus']")
      buttonPlus.classList.toggle('disabled', value >= max)
    }
  }
}
customElements.define('quantity-input', QuantityInput)
class HeaderDrawer extends HTMLElement {
  constructor() {
    super()
    this.header = document.querySelector('.main-header')
    this.drawerBtn = document.querySelector('.main-header__drawer-btn')
    this.eventListeners()
  }
  toggleState() {
    this.toggleClass(this.header, 'open')
    this.toggleClass(document.body, 'overflow-hidden')
    this.toggleClass(this, 'open')
  }
  eventListeners() {
    document.addEventListener('click', (e) => {
      if (e.target === this.drawerBtn) {
        this.toggleState()
      }
    })
  }
  toggleClass(item, cls) {
    if (item.classList.contains(cls)) {
      item.classList.remove(cls)
    } else {
      item.classList.add(cls)
    }
  }
}
customElements.define('header-drawer', HeaderDrawer)
class PopupModal extends HTMLElement {
  constructor() {
    super()
    this.modalId = null
    this.activeModal = null
    this.updateScrollHeight()
    this.eventListeners()
  }
  openModal(target) {
    this.modalId = target.dataset.modalTrigger || target.dataset.modalInputTrigger
    this.activeModal = document.querySelector(`[data-modal="${this.modalId}"]`)
    if (this.activeModal !== null) {
      this.activeModal.classList.add('opened')
      this.activeModal.classList.remove('closed')
    }
  }
  closeModal(target) {
    if (
      this.activeModal !== null &&
      this.activeModal.classList.contains('opened')
    ) {
      if (
        target.classList.contains('popup-content__inner') ||
        target.classList.contains('popup-content') || 
        target.hasAttribute('data-modal-close')
      ) {
        this.activeModal.classList.add('closed')
        this.activeModal.classList.remove('opened')
      }
    }
  }
  eventListeners() {
    document.addEventListener('click', (e) => {
      const target = e.target
      if (target.hasAttribute('data-modal-trigger')) {
        this.openModal(target)
      }
      if (target.hasAttribute('data-modal-input-trigger')) {
        if(target.checked) {
          this.openModal(target)
        }
      }
      this.closeModal(target)
    })
    document.addEventListener('keydown', (e) => {
      const key = e.key
      if (key === 'Enter') {
        this.openModal(e.target)
      }
      if (key === 'Escape') {
        if (
          this.activeModal !== null &&
          this.activeModal.classList.contains('opened')
        ) {
          this.activeModal.classList.add('closed')
          this.activeModal.classList.remove('opened')
        }
      }
    })
  }
  updateScrollHeight() {
    const popupHeader = this.querySelector('.popup-modal__header')
    const popupContent = this.querySelector('.popup-modal__content')
    if (popupHeader !== null) {
      popupContent.style.height = `calc(100% - ${popupHeader.offsetHeight}px)`
    }
  }
}
customElements.define('popup-modal', PopupModal)
